<div class="notification-box">
    <app-svg-icon [icon]="'notification'"></app-svg-icon>
    @if(notifications && notifications.length) {
        <span class="badge rounded-full badge-success text-white">{{ notifications.length }}</span>
    }
</div>

<div class="onhover-show-div notification-dropdown">
    <h6 class="mb-0 dropdown-title f-[18px]">Notifications</h6>

    <ul>
        @for(notification of notifications; track notification) {
            <li class="border-{{ notification.border_color }} toast default-show-toast items-center text-white fade show !border-l-4 !border-y-0 !border-r-0" aria-live="assertive" aria-atomic="true" data-bs-autohide="false">
                <div class="flex justify-between">
                  <div class="toast-body p-3">
                    <p>{{ notification.message }}</p>
                  </div>
                  <button class="btn-close ml-auto me-2" type="button" (click)="removeNotification(notification.id)"></button>
                </div>
            </li>
        } @empty {
            <li>
                There are no notifications.
            </li>
        }
    </ul>
</div>